<div class="layout-ParentDiv innerDiv"> 
        <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
            <div class="mainDivHeader">
                <div class="leftdiv">
                    <h4>Player Schedule - {{username}} <span class="badge">{{totalRecords }}</span></h4>
                </div>
                <!-- <div class="rightDiv">
                    <button class="exportBTn">
                        <span>
                            <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                        </span> Export
                    </button>
                </div> -->
            </div>
            <div class="mainDivBody">
                <div class="date-filterDiv">
                    <ul class="filtersList">
                        <li>
                            <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                                placeholder="Select Field" optionLabel="label"></p-dropdown>
                        </li>
                        <li>
                            <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar"
                                dateFormat="dd/mm/yy" placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
                        </li>
                        <li>
                            <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
                        </li>
                        <li>
                            <button (click)="loadschedulelist($event)" class="searchFilterBtn">
                                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                            </button>
                        </li>
                        <li>
                            <button (click)="clear()" class="clearFilterBtn">
                                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                                <span>Clear All</span>
                            </button>

                        </li>
                    </ul>
                </div>
                <div class="maintableDiv">
                    <div class="tableParanet">
                        <p-table class=" expandable" #dt [value]="partnerlist" [paginator]="true" [rows]="10"
                            [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                            (onLazyLoad)="loadschedulelist($event)" [totalRecords]="totalRecords" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption" autoLayout="true"
                            styleClass="p-datatable-gridlines p-datatable-striped">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th class="opponentUserNameTd" pSortableColumn="amenities" alignfrozen="left">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Opponent Name
                                            <p-sortIcon field="opponentUserName"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="startDateTd" style="left: 0px;" pSortableColumn="startDate">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            StartDate
                                            <p-sortIcon field="startDate"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="TimeTd" style="left: 0px;" pSortableColumn="startDate">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Start Time
                                            <p-sortIcon field="startDate"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="endTimeTd" style="left: 0px;" pSortableColumn="endDate">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            End Time
                                            <p-sortIcon field="endDate"></p-sortIcon>
                                        </div>
                                    </th>


                                    <th class="chargeTd" style="left: 0px;" pSortableColumn="charges">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Charges Per Hour
                                            <p-sortIcon field="charges"></p-sortIcon>
                                        </div>
                                    </th>


                                    <th class="statenameTd" 
                                        [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        style="left: 0px;" pSortableColumn="statename">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            State
                                            <p-sortIcon field="statename"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th  [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        class="citynameTd" style="left: 0px;" pSortableColumn="cityname">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            City
                                            <p-sortIcon field="cityname"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="venueTd" style="left: 0px;" pSortableColumn="venue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Venue
                                            <p-sortIcon field="venue"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th class="amenitiesTd" pSortableColumn="amenities" alignfrozen="right" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Ammenity
                                        </div>
                                    </th>
                                    <th class="statussTd" *ngIf="hidestatus" [ngClass]="hide ? 'hide-column' : 'show-column'"></th>
                                    <th   class="actionTD p-frozen-column" style="left: 0px;">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Action
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th [ngSwitch]="opponentUserName" class="opponentUserNameTd">
                                    <input #filterInput pInputText type="text" [(ngModel)]="opponentUserName"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'opponentUserName', 'contains')"
                                        [value]="dt.filters['opponentUserName'] ? dt.filters['opponentUserName'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="date" class="startDateTd">
                                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" 
                                            yearRange="2022:2050" 
                                            (onSelect)="dt.filter($event, 'startDate', 'dateIs')" 
                                            [(ngModel)]="calvalue"
                                            class="p-calendar w-100" inputId="calendar" 
                                            dateFormat="dd/mm/yy" [showIcon]="true">
                                        </p-calendar>
                                    </th>
                                    <!-- <th [ngSwitch]="startDate"  
                            class="p-element p-frozen-column col-td-main text-nowrap" style="left: 0px;">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'startDate', 'contains')"
                                [value]="dt.filters['startDate'] ? dt.filters['startDate'].value : ''" />
                        </th> -->
                                    <th [ngSwitch]="Time" class="TimeTd">
                                    </th>
                                    <th [ngSwitch]="endTime" class="endTimeTd">
                                    </th>
                                    <th [ngSwitch]="charges" class="chargeTd"
                                        style="left: 0px;">
                                        <input #filterInput pInputText type="text" [(ngModel)]="charges"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'charges', 'contains')"
                                            [value]="dt.filters['charges'] ? dt.filters['charges'].value : ''" />
                                        </th>
                                    <th [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        [ngSwitch]="statename" class="statenameTd"
                                        style="left: 0px;">
                                    <input #filterInput pInputText type="text"  [(ngModel)]="statename"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'statename', 'contains')"
                                        [value]="dt.filters['statename'] ? dt.filters['statename'].value : ''" />
                                    </th>
                                    <th [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        [ngSwitch]="cityname" class="citynameTd"
                                        style="left: 0px;">
                                <input #filterInput pInputText type="text"   [(ngModel)]="cityname"
                                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'cityname', 'contains')"
                                    [value]="dt.filters['cityname'] ? dt.filters['cityname'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="venue" class="venueTd" [ngClass]="hide ? 'hide-column' : 'show-column'"
                                        style="left: 0px;">
                                    <input #filterInput pInputText type="text" [(ngModel)]="venue"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'venue', 'contains')"
                                        [value]="dt.filters['venue'] ? dt.filters['venue'].value : ''" />
                                    </th>
                                    <th class="amenitiesTd"  [ngClass]="hide ? 'hide-column' : 'show-column'" >
                                        <!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->

                                    </th>
                                    <th class="statussTd" *ngIf="hidestatus" [ngClass]="hide ? 'hide-column' : 'show-column'"></th>
                                    <th [ngSwitch]="Time" class="actionTD p-frozen-column" alignfrozen="right">
                                        <div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
                                        <!-- <button pButton pRipple label="Columns" icon="pi pi-plus"
                                            [ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
                                            (click)="setDownloadFlag(); addColumns()"></button>
                                        <button pButton pRipple label="Columns" icon="pi pi-minus"
                                            [ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
                                            (click)="setDownloadFlag(); removeColumns()"></button> -->
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-partner>

                                <tr class="p-selectable-row">
                                    <td class="opponentUserNameTd" alignfrozen="left" style="width: 200px; left: 0px;">
                                        {{partner.opponentUserName}}
                                    </td>

                                    <td class=" startDateTd">
                                        {{partner.startDate | date : 'dd/MM/yyyy'}}
                                        <!-- date -->
                                    </td>

                                    <td class="TimeTd">
                                        <div *ngFor="let slot of partner.displayTimeSlots">
                                            {{slot.startTime}}
                                        </div>
                                        <!-- start time -->
                                    </td>
                                    <td class="endTimeTd">
                                        <div *ngFor="let slot of partner.displayTimeSlots">
                                            {{slot.endTime}}
                                        </div>
                                        <!-- end time -->
                                    </td>
                                    <td class="chargeTd">
                                        {{partner.charges}}
                                    </td>
                                    <td [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        class="statenameTd">
                                        {{partner.statename}}
                                    </td>
                                    <td [ngClass]="hide ? 'hide-col text-nowrap col-td-main ' : 'show-col text-nowrap col-td-main'"
                                        class="citynameTd">
                                        {{partner.cityname}}
                                    </td>
                                    <td class="venueTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        {{partner.venue}}
                                    </td>
                                  
                                    <td class=" amenitiesTd" alignfrozen="right" [ngClass]="hide ? 'hide-column' : 'show-column'"
                                        style="width: 200px; right: 0px;">
                                        <span *ngFor="let image of partner.amenityImg"
                                            [ngClass]="image.status ? 'active':'span'">
                                            <img [src]="image.img" style="height: 35px;width: 35px;padding-left: 10px;"
                                                pTooltip="{{image.slug}}" tooltipPosition="bottom">
                                        </span>
                                    </td>
                                      <td class="statussTd" *ngIf="hidestatus" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="status-buttons" *ngIf="hidestatus">
                                            <button class="btn btn-success"
                                                (click)="approveuser(partner)">Approve</button>
                                            <button class="btn btn-danger" (click)="rejectuser(partner)">
                                                Reject</button>
                                        </div>
                                    </td>

                                    <td class="actionTD p-frozen-column">
                                        <div class="status-buttons">
                                            <div class="return-money-button">
                                                <i *ngIf="partner.creditInvoiceFile" pTooltip="View credit note"
                                                    tooltipPosition="bottom" class="bx bxs-file-pdf"
                                                    style="color: red; font-size: 18px; cursor: pointer;"
                                                    (click)="downloadPdf(partner.creditInvoiceFile)"></i>
                                                <button *ngIf="!partner.creditInvoiceFile && partner.isRefunded"
                                                    class="btn btn-danger disabled-button" disabled>
                                                    Refunded
                                                </button>
                                                <button *ngIf="!partner.creditInvoiceFile && !partner.isRefunded" class="btn btn-danger" (click)="returnCash(partner)"
                                                    [disabled]="isReturnButtonDisabled(partner)"
                                                    [ngClass]="{ 'disabled-button': isReturnButtonDisabled(partner) }">
                                                    <span class="icons">
                                                        <img src="../../../../assets/images/backend-image/header/return.svg" alt="">
                                                    </span> Return
                                                </button>
                                            </div>
                                            <button *ngIf="partner.opponentUserId" 
                                                (click)="viewChatHistory(partner)" 
                                                class="chatBtn"
                                                pTooltip="Chat History" tooltipPosition="bottom">
                                                <img src="../../../assets/images/home-page/chat.svg">
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="10">No Player Schedule found.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div> 
</div>
    <p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
